import { render, staticRenderFns } from "./PwSearch.vue?vue&type=template&id=024eb1da&scoped=true&"
import script from "./PwSearch.vue?vue&type=script&lang=js&"
export * from "./PwSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024eb1da",
  null
  
)

export default component.exports